import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.19.2_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22.19.11_@vue+compil_840e48bf683d229cb72546e3ba5a5c0c/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/vercel/path0/node_modules/.pnpm/@una-ui+content@49.0.0-beta.5_@netlify+blobs@9.1.2_@parcel+watcher@2.5.1_@types+node@22_33f1de760399641e0d9310fb49b824a8/node_modules/@una-ui/content/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions1.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}